<template>
  <section class="dp-layout tp-page">
    <section class="dp-right">
      <el-tabs v-model="platformTab" class="tp-tabs" @tab-click="handleTabChange">
        <el-tab-pane label="微信" name="wechat" />
        <el-tab-pane label="钉钉" name="dingtalk" />
      </el-tabs>

      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

      <!-- 微信列表 -->
      <template v-if="platformTab === 'wechat'">
        <div class="tbl-scroll-host">
          <el-table :data="tableData" highlight-current-row v-loading="listLoading" @select="dialogCheck"
            @selection-change="handleWechatSelectionChange"
            @row-click="selectCurrentRow" style="width: 100%;" height="100%" class="custom-tbl" ref="wechatTable">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" width="60" label="#"></el-table-column>
            <el-table-column prop="publicAccount" label="微信公众号ID" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="publicNick" label="微信公众号名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="appid" label="AppID" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <el-col :span="24" class="toolbar">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="page.pageIndex"
            :page-size="page.pageSize" :page-sizes="[10, 100, 1000]"
            layout="total, sizes, prev, pager, next, jumper" :total="page.pageTotal" style="float:right;">
          </el-pagination>
        </el-col>
      </template>

      <!-- 钉钉列表 -->
      <template v-else>
        <div class="tbl-scroll-host">
          <el-table :data="dingTableData" highlight-current-row v-loading="dingListLoading" @select="dingDialogCheck"
            @selection-change="handleDingSelectionChange"
            @row-click="selectDingCurrentRow" style="width: 100%;" height="100%" class="custom-tbl" ref="dingTable">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" width="60" label="#"></el-table-column>
            <el-table-column prop="Name" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="AgentId" label="AgentId" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="CorpId" label="CorpId" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="Appkey" label="AppKey" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" width="168">
              <template slot-scope="scope">{{ formatTime(scope.row.CreateTime) }}</template>
            </el-table-column>
          </el-table>
        </div>
        <el-col :span="24" class="toolbar">
          <el-pagination @size-change="handleDingSizeChange" @current-change="handleDingCurrentChange"
            :current-page.sync="dingPage.pageIndex"
            :page-size="dingPage.pageSize" :page-sizes="[10, 100, 1000]"
            layout="total, sizes, prev, pager, next, jumper" :total="dingPage.pageTotal" style="float:right;">
          </el-pagination>
        </el-col>
      </template>

      <!-- 微信编辑弹窗 -->
      <el-dialog :title="wechatDialogTitle" :visible.sync="editFormVisible" width="560px"
        custom-class="dialog-theme tp-config-dialog" :close-on-click-modal="false" append-to-body>
        <el-alert type="info" :closable="false" show-icon class="tp-config-hint"
          title="学校机构管理中的「第三方 ID」需填写本配置的 AppID；若修改 AppID，请到机构管理同步更新已绑定学校。" />
        <el-form :model="editForm" label-width="120px" size="small" :rules="editFormRules" ref="editForm"
          class="tp-config-form" autocomplete="off">
          <el-form-item label="微信公众号ID" prop="publicAccount">
            <el-input v-model="editForm.publicAccount" placeholder="如 gh_xxx" :disabled="editType === 'edit'"
              autocomplete="off" data-lpignore="true" data-1p-ignore="true"></el-input>
          </el-form-item>
          <el-form-item label="公众号名称" prop="publicNick">
            <el-input v-model="editForm.publicNick" placeholder="显示名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="AppID" prop="appid">
            <el-input v-model="editForm.appid" placeholder="微信应用 AppID" autocomplete="off"
              data-lpignore="true" data-1p-ignore="true"></el-input>
          </el-form-item>
          <el-form-item label="AppSecret" prop="appsecret">
            <password-input :key="'wechat-secret-' + wechatSecretInputKey" v-model="editForm.appsecret"
              placeholder="应用密钥"></password-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="editForm.remark" type="textarea" :rows="2" placeholder="可选"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="editFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="editSubmit" :loading="editLoading">保存</el-button>
        </div>
      </el-dialog>

      <!-- 钉钉编辑弹窗 -->
      <el-dialog :title="dingDialogTitle" :visible.sync="dingEditVisible" width="560px"
        custom-class="dialog-theme tp-config-dialog" :close-on-click-modal="false" append-to-body>
        <el-alert type="info" :closable="false" show-icon class="tp-config-hint"
          title="学校机构管理中的「第三方 ID」需填写本配置的 AppKey；若修改 AppKey，请到机构管理同步更新已绑定学校。" />
        <el-form :model="dingEditForm" label-width="120px" size="small" :rules="dingEditRules" ref="dingEditForm"
          class="tp-config-form" autocomplete="off">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="dingEditForm.Name" placeholder="如 临海市灵江中学" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="AgentId" prop="AgentId">
            <el-input v-model="dingEditForm.AgentId" placeholder="钉钉应用 AgentId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="CorpId" prop="CorpId">
            <el-input v-model="dingEditForm.CorpId" placeholder="钉钉企业 CorpId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="AppKey" prop="Appkey">
            <el-input v-model="dingEditForm.Appkey" placeholder="ding 开头" autocomplete="off"
              data-lpignore="true" data-1p-ignore="true"></el-input>
          </el-form-item>
          <el-form-item label="AppSecret" prop="Appsecret">
            <password-input :key="'ding-secret-' + dingSecretInputKey" v-model="dingEditForm.Appsecret"
              :placeholder="dingEditType === 'edit' ? '留空表示不修改' : '应用密钥'"></password-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dingEditVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="dingEditSubmit" :loading="dingEditLoading">保存</el-button>
        </div>
      </el-dialog>

      <!-- 删除操作授权 -->
      <el-dialog title="操作授权确认" :visible.sync="deleteAuthVisible" width="450px"
        custom-class="dialog-theme tp-delete-auth-dialog" :close-on-click-modal="false" append-to-body
        @closed="resetDeleteAuth">
        <div class="tp-delete-auth">
          <div class="tp-delete-auth__icon">
            <i class="el-icon-lock"></i>
          </div>
          <div class="tp-delete-auth__tips">{{ deleteAuthTips }}</div>
          <el-form :model="deleteAuthForm" :rules="deleteAuthRules" ref="deleteAuthForm" label-width="0">
            <el-form-item prop="authCode">
              <password-input v-model="deleteAuthForm.authCode" placeholder="请输入操作授权密码"
                @keyup.enter.native="confirmDeleteAuth"></password-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="deleteAuthVisible = false">取消</el-button>
          <el-button size="small" type="danger" :loading="deleteAuthLoading" @click="confirmDeleteAuth">确认删除</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getWeChatAccount, removeWeChatAccount, addWeChatAccount, updateWeChatAccount,
  batchDeleteChatAccount, refreshWeChatToken
} from '../../api/modules/wechat';
import {
  getDingTalkConfig as fetchDingTalkConfig, removeDingTalkConfig, addDingTalkConfig,
  updateDingTalkConfig, batchDeleteDingTalkConfig
} from '../../api/modules/dingtalk';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import PasswordInput from '../../components/PasswordInput';

export default {
  components: { Toolbar, PasswordInput },
  data() {
    return {
      platformTab: 'wechat',
      wechatSecretInputKey: 0,
      dingSecretInputKey: 0,
      filters: { name: '' },
      buttonList: [],
      listLoading: false,
      tableData: [],
      sels: [],
      currentRow: null,
      page: { pageSize: 10, pageIndex: 1, pageTotal: 0 },
      editFormVisible: false,
      editLoading: false,
      editType: 'add',
      editForm: {},
      editFormRules: {
        publicAccount: [{ required: true, message: '请填写微信公众号ID', trigger: 'blur' }],
        publicNick: [{ required: true, message: '请填写公众号名称', trigger: 'blur' }],
        appid: [{ required: true, message: '请输入 AppID', trigger: 'blur' }],
        appsecret: [{ required: true, message: '请输入 AppSecret', trigger: 'blur' }]
      },
      dingListLoading: false,
      dingTableData: [],
      dingSels: [],
      dingCurrentRow: null,
      dingPage: { pageSize: 10, pageIndex: 1, pageTotal: 0 },
      dingEditVisible: false,
      dingEditLoading: false,
      dingEditType: 'add',
      dingEditForm: {},
      deleteAuthVisible: false,
      deleteAuthLoading: false,
      deleteAuthForm: { authCode: '' },
      deleteAuthRules: {
        authCode: [{ required: true, message: '请输入操作授权密码', trigger: 'blur' }]
      },
      pendingDeleteAction: null,
      dingEditRules: {
        Name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
        AgentId: [{ required: true, message: '请填写 AgentId', trigger: 'blur' }],
        CorpId: [{ required: true, message: '请填写 CorpId', trigger: 'blur' }],
        Appkey: [{ required: true, message: '请填写 AppKey', trigger: 'blur' }],
        Appsecret: [{
          validator: (rule, value, callback) => {
            if (this.dingEditType === 'add' && !value) {
              callback(new Error('请填写 AppSecret'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    wechatDialogTitle() {
      return this.editType === 'add' ? '新增微信配置' : '编辑微信配置';
    },
    dingDialogTitle() {
      return this.dingEditType === 'add' ? '新增钉钉配置' : '编辑钉钉配置';
    },
    deleteAuthTips() {
      const action = this.pendingDeleteAction;
      if (!action) return '请输入专属操作授权密码以确认身份。';
      const platform = action.platform === 'dingtalk' ? '钉钉' : '微信';
      if (action.mode === 'batch') {
        return `您正在尝试批量删除 ${action.count} 条${platform}平台配置，请输入专属操作授权密码以确认身份。`;
      }
      const name = action.label || '所选';
      return `您正在尝试删除 [${name}] 的${platform}平台配置，请输入专属操作授权密码以确认身份。`;
    }
  },
  created() {
    this.loadWechatList();
  },
  methods: {
    handleTabChange() {
      this.currentRow = null;
      this.dingCurrentRow = null;
      if (this.platformTab === 'wechat') {
        this.loadWechatList();
      } else {
        this.loadDingList();
      }
    },
    formatTime(val) {
      if (!val) return '—';
      return String(val).replace('T', ' ').slice(0, 19);
    },

    /* ---------- 微信 ---------- */
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.wechatTable.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },
    selectCurrentRow(val) {
      if (!val) return;
      this.currentRow = val;
      this.$refs.wechatTable.clearSelection();
      this.$refs.wechatTable.toggleRowSelection(val, true);
    },
    handleWechatSelectionChange(selection) {
      this.sels = selection || [];
    },
    handleCurrentChange(index) {
      this.page.pageIndex = index;
      this.currentRow = null;
      if (this.$refs.wechatTable) this.$refs.wechatTable.clearSelection();
      this.loadWechatList();
    },
    handleSizeChange(val) {
      this.page.pageIndex = 1;
      this.page.pageSize = val;
      this.currentRow = null;
      if (this.$refs.wechatTable) this.$refs.wechatTable.clearSelection();
      this.loadWechatList();
    },
    loadWechatList() {
      this.listLoading = true;
      const para = {
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        orderByFileds: ''
      };
      if (this.filters.name) {
        para.conditions = 'publicNick like ' + this.filters.name + ' | publicAccount like ' + this.filters.name;
      }
      getWeChatAccount(para).then(res => {
        this.listLoading = false;
        if (res.data.success) {
          this.tableData = res.data.response.data || [];
          this.page.pageTotal = res.data.response.dataCount || 0;
        }
      }).catch(() => { this.listLoading = false; });
    },
    handleRefreshWeChatToken() {
      if (!this.currentRow) {
        this.$message.error('请选择要操作的数据行');
        return;
      }
      refreshWeChatToken({ id: this.currentRow.Id }).then(res => {
        if (res.data.success) {
          this.loadWechatList();
          this.$message.success('刷新 Token 成功');
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleDel() {
      if (this.platformTab === 'dingtalk') return this.openDeleteAuth('dingtalk', 'single');
      if (!this.currentRow) {
        this.$message.error('请选择要操作的数据行');
        return;
      }
      this.openDeleteAuth('wechat', 'single');
    },
    handleEdit() {
      if (this.platformTab === 'dingtalk') return this.handleDingEdit();
      if (!this.currentRow) {
        this.$message.error('请选择要操作的数据行');
        return;
      }
      this.editFormVisible = true;
      this.editType = 'edit';
      this.wechatSecretInputKey += 1;
      this.editForm = Object.assign({}, this.currentRow);
    },
    handleAdd() {
      if (this.platformTab === 'dingtalk') return this.handleDingAdd();
      this.editFormVisible = true;
      this.editType = 'add';
      this.wechatSecretInputKey += 1;
      this.editForm = { Enabled: true };
    },
    buildSubmitPayload() {
      const payload = Object.assign({}, this.editForm);
      delete payload.token;
      delete payload.interactiveToken;
      delete payload.tokenExpiration;
      if (this.editType === 'add' && payload.Enabled === undefined) {
        payload.Enabled = true;
      }
      return payload;
    },
    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.$confirm('确认保存吗？', '提示', {}).then(() => {
          this.editLoading = true;
          const postPara = this.buildSubmitPayload();
          const req = this.editType === 'add'
            ? addWeChatAccount(postPara)
            : updateWeChatAccount(postPara);
          req.then(res => {
            this.editLoading = false;
            if (res.data.success) {
              this.loadWechatList();
              this.editFormVisible = false;
              this.$message.success(this.editType === 'add' ? '添加成功' : '修改成功');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => { this.editLoading = false; });
        });
      });
    },
    batchRemove() {
      if (this.platformTab === 'dingtalk') return this.openDeleteAuth('dingtalk', 'batch');
      if (!(this.sels.length > 0)) {
        this.$message.error('请选择要操作的数据行');
        return;
      }
      this.openDeleteAuth('wechat', 'batch');
    },

    openDeleteAuth(platform, mode) {
      if (mode === 'single') {
        const row = platform === 'dingtalk' ? this.dingCurrentRow : this.currentRow;
        if (!row) {
          this.$message.error('请选择要操作的数据行');
          return;
        }
        const label = platform === 'dingtalk'
          ? (row.Name || row.Appkey || row.Id)
          : (row.publicNick || row.publicAccount || row.appid || row.Id);
        this.pendingDeleteAction = { platform, mode, label, id: row.Id };
      } else {
        const selected = platform === 'dingtalk' ? this.dingSels : this.sels;
        if (!(selected.length > 0)) {
          this.$message.error('请选择要操作的数据行');
          return;
        }
        this.pendingDeleteAction = {
          platform,
          mode,
          count: selected.length,
          ids: selected.map(item => item.Id).join(',')
        };
      }
      this.deleteAuthForm.authCode = '';
      this.deleteAuthVisible = true;
      this.$nextTick(() => {
        if (this.$refs.deleteAuthForm) this.$refs.deleteAuthForm.clearValidate();
      });
    },
    resetDeleteAuth() {
      this.deleteAuthForm.authCode = '';
      this.pendingDeleteAction = null;
      this.deleteAuthLoading = false;
    },
    confirmDeleteAuth() {
      this.$refs.deleteAuthForm.validate(valid => {
        if (!valid || !this.pendingDeleteAction) return;
        this.deleteAuthLoading = true;
        const authCode = this.deleteAuthForm.authCode;
        const action = this.pendingDeleteAction;
        let req;
        if (action.platform === 'dingtalk') {
          req = action.mode === 'batch'
            ? batchDeleteDingTalkConfig({ ids: action.ids, authCode })
            : removeDingTalkConfig({ id: action.id, authCode });
        } else {
          req = action.mode === 'batch'
            ? batchDeleteChatAccount({ ids: action.ids, authCode })
            : removeWeChatAccount({ id: action.id, authCode });
        }
        req.then(res => {
          this.deleteAuthLoading = false;
          if (res.data.success) {
            this.deleteAuthVisible = false;
            if (action.platform === 'dingtalk') this.loadDingList();
            else this.loadWechatList();
            this.$message.success(action.mode === 'batch' ? '批量删除成功' : '删除成功');
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        }).catch(() => { this.deleteAuthLoading = false; });
      });
    },

    /* ---------- 钉钉 ---------- */
    dingDialogCheck(selection, row) {
      this.dingCurrentRow = null;
      this.$refs.dingTable.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectDingCurrentRow(row);
    },
    selectDingCurrentRow(val) {
      if (!val) return;
      this.dingCurrentRow = val;
      this.$refs.dingTable.clearSelection();
      this.$refs.dingTable.toggleRowSelection(val, true);
    },
    handleDingSelectionChange(selection) {
      this.dingSels = selection || [];
    },
    handleDingCurrentChange(index) {
      this.dingPage.pageIndex = index;
      this.dingCurrentRow = null;
      if (this.$refs.dingTable) this.$refs.dingTable.clearSelection();
      this.loadDingList();
    },
    handleDingSizeChange(val) {
      this.dingPage.pageIndex = 1;
      this.dingPage.pageSize = val;
      this.dingCurrentRow = null;
      if (this.$refs.dingTable) this.$refs.dingTable.clearSelection();
      this.loadDingList();
    },
    getWeChatAccount() {
      this.loadWechatList();
    },
    /**
     * 钉钉配置行字段归一化：Newtonsoft 可能将 CorpId 序列化为 Corpid。最后更新：2026-09-01
     */
    normalizeDingConfigRow(row) {
      if (!row || typeof row !== 'object') return {};
      const corpId = row.CorpId != null ? row.CorpId
        : (row.Corpid != null ? row.Corpid
          : (row.corpId != null ? row.corpId : ''));
      return { ...row, CorpId: corpId };
    },
    loadDingList() {
      this.dingListLoading = true;
      const para = {
        pageIndex: this.dingPage.pageIndex,
        pageSize: this.dingPage.pageSize,
        orderByFileds: 'CreateTime desc'
      };
      if (this.filters.name) {
        const key = this.filters.name;
        para.conditions = [
          'Name like ' + key,
          'AgentId like ' + key,
          'CorpId like ' + key,
          'Appkey like ' + key
        ].join(' | ');
      }
      fetchDingTalkConfig(para).then(res => {
        this.dingListLoading = false;
        if (res.data.success) {
          this.dingTableData = (res.data.response.data || []).map(row => this.normalizeDingConfigRow(row));
          this.dingPage.pageTotal = res.data.response.dataCount || 0;
        }
      }).catch(() => { this.dingListLoading = false; });
    },
    handleDingAdd() {
      this.dingEditVisible = true;
      this.dingEditType = 'add';
      this.dingSecretInputKey += 1;
      this.dingEditForm = {};
      this.$nextTick(() => {
        if (this.$refs.dingEditForm) this.$refs.dingEditForm.clearValidate();
      });
    },
    handleDingEdit() {
      if (!this.dingCurrentRow) {
        this.$message.error('请选择要操作的数据行');
        return;
      }
      this.dingEditVisible = true;
      this.dingEditType = 'edit';
      this.dingSecretInputKey += 1;
      this.dingEditForm = Object.assign({ Appsecret: '' }, this.normalizeDingConfigRow(this.dingCurrentRow));
      this.$nextTick(() => {
        if (this.$refs.dingEditForm) this.$refs.dingEditForm.clearValidate();
      });
    },
    dingEditSubmit() {
      this.$refs.dingEditForm.validate(valid => {
        if (!valid) return;
        this.$confirm('确认保存吗？', '提示', {}).then(() => {
          this.dingEditLoading = true;
          const payload = Object.assign({}, this.dingEditForm);
          if (this.dingEditType === 'edit' && !payload.Appsecret) {
            delete payload.Appsecret;
          }
          const req = this.dingEditType === 'add'
            ? addDingTalkConfig(payload)
            : updateDingTalkConfig(payload);
          req.then(res => {
            this.dingEditLoading = false;
            if (res.data.success) {
              this.loadDingList();
              this.dingEditVisible = false;
              this.$message.success(this.dingEditType === 'add' ? '添加成功' : '修改成功');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => { this.dingEditLoading = false; });
        });
      });
    },
    handleDingDel() {
      this.openDeleteAuth('dingtalk', 'single');
    },
    batchDingRemove() {
      this.openDeleteAuth('dingtalk', 'batch');
    },

    callFunction(item) {
      this.filters = { name: item.search || '' };
      if (item.Func === 'getWeChatAccount') {
        if (this.platformTab === 'dingtalk') {
          this.dingPage.pageIndex = 1;
          this.loadDingList();
        } else {
          this.page.pageIndex = 1;
          this.loadWechatList();
        }
        return;
      }
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func].apply(this, item);
      }
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.tp-page >>> .tp-tabs {
  flex: 0 0 auto;
  margin-bottom: 8px;
}

.tp-page >>> .tp-tabs > .el-tabs__header {
  margin: 0 0 8px;
}

.tp-page >>> .tp-tabs > .el-tabs__content {
  display: none;
}

.tp-page >>> .tp-tabs .el-tabs__item {
  height: 38px;
  line-height: 38px;
  font-size: 13px;
}

.tp-config-hint {
  margin-bottom: 14px;
}

.tp-config-form >>> .el-form-item {
  margin-bottom: 16px;
}

.tp-config-form >>> .el-form-item:last-child {
  margin-bottom: 0;
}

.tp-config-form >>> .el-input,
.tp-config-form >>> .el-textarea {
  width: 100%;
}

.tp-config-form >>> .password-input-wrap .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>

<style>
/* 第三方平台配置弹窗：配合全站 dialog-theme。最后修改：2026-08-29 */
.el-dialog.dialog-theme.tp-config-dialog .el-dialog__body {
  padding: 16px 20px 20px;
}

.el-dialog.dialog-theme.tp-config-dialog .el-form-item__label {
  color: #64748b;
  font-weight: 500;
  line-height: 32px;
}

.el-dialog.dialog-theme.tp-config-dialog .el-input__inner,
.el-dialog.dialog-theme.tp-config-dialog .el-textarea__inner {
  border-radius: 8px;
}

.tp-delete-auth {
  text-align: center;
  padding: 8px 6px 0;
}

.tp-delete-auth__icon {
  font-size: 54px;
  color: #e6a23c;
  margin-bottom: 16px;
}

.tp-delete-auth__tips {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
  line-height: 1.6;
  text-align: left;
}

.tp-delete-auth >>> .password-input-wrap {
  text-align: left;
}
</style>
